import Vue from 'vue';
import injector from 'vue-inject';

require('../../start');

Vue.use(injector);

let api     = injector.get('api'),
    status  = injector.get('status');

const state = {
    ranking: [],

    rankingSettings: {
        currentPage: 1,
        numberOfPages: 1,
        maxPerPage: 25,
        careerLevel: 'vip'
    }
};

const getters = {
    ranking: state => {
        return state.ranking
    },

    rankingSettings: state => {
        return state.rankingSettings
    }
};

const mutations = {
    /**
     * Set career level
     * @param getters
     * @param data
     * @returns {Promise}
     */
    rankingSetCareerLevel (state, data) {
        Vue.set(state.rankingSettings, 'careerLevel', data);
    },

    /**
     * Set ranking in store
     * @param state
     * @param data
     */
    setRanking (state, data) {
        if (data.results.length > 0) {
            Vue.set(state, 'ranking', data.results);
        } else {
            Vue.set(state, 'ranking', []);
        }
        Vue.set(state.rankingSettings, 'currentPage', data.current_page);
        Vue.set(state.rankingSettings, 'maxPerPage', data.max_per_page);
        Vue.set(state.rankingSettings, 'numberOfPages', data.number_of_pages);
    }
};

const actions = {

    /**
     * Get ranking data from api
     * @param commit
     * @returns {Promise.<void>}
     */
    async loadRanking ({ commit }) {
        return new Promise((resolve, reject) => {
            let settings = state.rankingSettings;

            Vue.http.get(api.ranking.list(settings)).then(response => {
                commit('setRanking', response.data);
                resolve();
            }, error => {
                status['status' + error.status]();
                reject();
            });
        });
    },

    /**
     * Set max number of items in ranking
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async rankingSetItems ({}, data) {
        return new Promise((resolve) => {
            Vue.set(state.rankingSettings, 'maxPerPage', data);

            resolve();
        });
    },

    /**
     * Set page in ranking
     * @param getters
     * @param data
     * @returns {Promise}
     */
    async rankingSetPage ({}, data) {
        return new Promise((resolve) => {
            Vue.set(state.rankingSettings, 'currentPage', data);
            resolve();
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ranking.js